import React from 'react'
import styled from 'styled-components'

import DivButton from '@jarvis.oddle/core/components/DivButton'
import { colorConstants, margin, marginSizes } from '@jarvis.oddle/core/theme/default'

import IconHamburger from 'src/components/icons/IconNewHamburger'

const StyledDivButton = styled(DivButton)`
  margin-top: ${margin[marginSizes.extraSmall]};
`

const Hamburger = ({
  onClick,
  fill = colorConstants
}: {
  onClick: () => void
  fill: string
}): JSX.Element => {
  return (
    <StyledDivButton onClick={onClick}>
      <IconHamburger fill={fill} width='32px' height='32px' />
    </StyledDivButton>
  )
}

export default Hamburger
